import { render, staticRenderFns } from "./NewsletterSignup.vue?vue&type=template&id=dfb04882"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports